/**
 * Parses Magento `shipping_time` custom attribute values like `"8 d"`.
 * Returns null when missing or not matching the expected format.
 */
export function parseShippingTimeDays(
  value: string | null | undefined
): number | null {
  if (value == null || value.trim() === '') {
    return null;
  }

  const match = /^(\d+)/.exec(value.trim());
  if (!match) {
    return null;
  }

  return Number.parseInt(match[1], 10);
}
